module.exports = __webpack_public_path__ + "fonts/4e1954f8260aabe114d454e7227ff22b.woff";